import styled from "styled-components";
import EntryLoopOpen from "./EntryLoop";
import {observer} from "mobx-react";
import EntryItem from "./EntryItem";
import React from "react";
import FolderAddView from "./FolderAddView";
import BookmarkAddView from "./BookmarkAddView";
import {useFolderStore} from "../../app/store/FolderStore";

/**
 *
 * @param {string} treeType
 * @param {string} entryType
 * @param {function} mutateFoldersAndBookmarks
 * @param {boolean?} isActionModal
 * @param {number?} modalDepth
 * @param {string?} targetPath
 * @param {boolean?} withIcon
 * @param {boolean?} withFiles
 * @param {Element?} parentTabWrap
 * @return {Element}
 * @constructor
 */
const TreeView = ({
                      treeType,
                      entryType,
                      mutateFoldersAndBookmarks,
                      isActionModal,
                      modalDepth,
                      targetPath,
                      withIcon,
                      withFiles,
                      parentTabWrap,
                  }) => {
    const folderStore = useFolderStore();
    if (treeType === 'Bookmark') {
        return (
            <div>
                <ListContainer>
                    {
                        folderStore.getBookmarks(entryType, isActionModal).map((entry, idx) => (
                            <EntryLoopOpen
                                entryType={entryType}
                                entry={entry}
                                depth={0}
                                key={idx}
                                mutateFoldersAndBookmarks={mutateFoldersAndBookmarks}
                                isActionModal={isActionModal}
                                modalDepth={modalDepth}
                                targetPath={targetPath}
                                withIcon={withIcon}
                                withFiles={withFiles}
                                parentTabWrap={parentTabWrap}
                            />
                        ))
                    }
                    {
                        folderStore.getAddBookmark(entryType, isActionModal) !== undefined &&
                        <BookmarkAddView
                            entryType={entryType}
                            isActionModal={isActionModal}
                            mutateFoldersAndBookmarks={mutateFoldersAndBookmarks}
                        />
                    }
                </ListContainer>
            </div>
        )
    } else {
        return (
            <div>
                <ListContainer>
                    {
                        folderStore.getFolders(entryType, isActionModal).children.map((entry, idx) => (
                            <EntryLoopOpen
                                entryType={entryType}
                                entry={entry}
                                depth={entry.depth}
                                key={idx}
                                mutateFoldersAndBookmarks={mutateFoldersAndBookmarks}
                                isActionModal={isActionModal}
                                modalDepth={modalDepth}
                                targetPath={targetPath}
                                withIcon={withIcon}
                                withFiles={withFiles}
                            />
                        ))
                    }
                    {
                        folderStore.addFolder.TREE && folderStore.getCurrent(entryType).depth === 0 && folderStore.getFolders(entryType).children &&
                        <FolderAddView
                            entryType={entryType}
                            depth={0}
                            modalDepth={modalDepth}
                            mutateFoldersAndBookmarks={mutateFoldersAndBookmarks}
                        />
                    }
                    {
                        withFiles && folderStore.getFolders(entryType, isActionModal).files && folderStore.getFolders(entryType, isActionModal).files.length > 0 &&
                        folderStore.getFolders(entryType, isActionModal).files.map((file, idx) => (
                            <EntryItem id={file._id} path={file.parent} key={`entry-item-${idx}`} name={file.name}
                                       idx={idx}
                                       board={file.board} type={file.type}
                                       mutateFoldersAndBookmarks={mutateFoldersAndBookmarks}
                                       depth={file.depth - 1}/>
                        ))
                    }
                </ListContainer>
            </div>
        )
    }
};

export default observer(TreeView);

const ListContainer = styled.div`
    display: flex;
    flex-direction: column;
`;
const Root = styled.div`
    font-weight: 700;
`;
